import { useQuery } from "@tanstack/react-query";
import {
  submissionDocumentsApi,
  type ReportSubmissionDocumentDto,
} from "@/api/reportsV32";

// LLM & Reports v3.2 §8.1 step 4 — fetches the full ReportSubmissionDocument
// list for a submission. Disabled when submissionId is null (the user is
// still on the title / form steps and no submission row exists yet).
//
// Using a stable key per submission lets every mutation in Stage 2
// (attach / detach / update tag / retry) invalidate this single query and
// have the row list re-render with the latest server truth.
export function useSubmissionDocuments(submissionId: string | null) {
  return useQuery<ReportSubmissionDocumentDto[]>({
    queryKey: ["submission-documents", submissionId],
    queryFn: () =>
      submissionId
        ? submissionDocumentsApi.list(submissionId)
        : Promise.resolve([]),
    enabled: Boolean(submissionId),
  });
}
